import { Component, inject } from '@angular/core'
import { ButtonModule } from 'primeng/button'
import { DropdownModule } from 'primeng/dropdown'
import { NavigationService } from 'src/app/shared/services/navigation.service'
import { Router, RouterModule } from '@angular/router'
import { FormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { AzureService, MappingGroup } from 'src/app/core/auth/azure.service'
import { BehaviorSubject, Subscription } from 'rxjs'
import { environment } from 'src/environments/environment'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    DropdownModule,
    ButtonModule,
    RouterModule,
    CommonModule,
    FormsModule,
  ],
})
export class HeaderComponent {
  showSettingsPage: boolean = environment.debugShowSettings
  private roleSubscription: Subscription | undefined
  userGroups: { label: string; value: string }[] = []
  selectedBusinessArea = ''
  environment = environment
  constructor(private router: Router) {}

 ngOnInit() {
  this.roleSubscription = this.azureService.rolesSubject.subscribe((roles) => {
    this.userGroups = roles.map((role: any) => ({
      label: role.name,
      value: role.id,
      title: role.name,
    }));

    if (roles.length > 0) {
      this.selectedBusinessArea = roles[0].id;
      this.azureService.selectedBusinessArea.next(this.selectedBusinessArea);

      const initialRole = roles[0].name;
      this.azureService.selectedRole.next(initialRole);
      this.updateSettingsPageVisibility(roles[0].id, initialRole);
    }
  });

  this.azureService.selectedRole.subscribe((roleName: string) => {
    const roles = this.azureService.rolesSubject.value;
    const currentRole = roles.find((r: any) => r.name === roleName);
    if (currentRole) {
      this.updateSettingsPageVisibility(currentRole.id, roleName);
    }
  });
}
  ngOnDestroy() {
    // Unsubscribe to prevent memory leaks
    if (this.roleSubscription) {
      this.roleSubscription.unsubscribe()
    }
  }

  private navigationService = inject(NavigationService)
  private azureService = inject(AzureService)

  openSidebar(): void {
    this.navigationService.toggleSidebar(true)
  }

  changeBusinessArea(event: any): void {
    const roles = this.azureService.rolesSubject.value;
    const changedRole = roles.find((role: MappingGroup) => role.id === event)
    this.azureService.selectedRole.next(changedRole.role)
    this.azureService.selectedBusinessArea.next(changedRole.id)
    this.updateSettingsPageVisibility(changedRole.id, changedRole.name)
  }

  private updateSettingsPageVisibility(roleId: string, roleName: string): void {
    this.showSettingsPage = environment.debugShowSettings || 
      this.isSpAdmin(roleName) || 
      this.azureService.isAdminRole(roleId);
  }

  isLinkActive(url: string): boolean {
    const queryParamsIndex = this.router.url.indexOf('?')
    const baseUrl =
      queryParamsIndex === -1
        ? this.router.url
        : this.router.url.slice(0, queryParamsIndex)
    return baseUrl === url
  }

  isSpAdmin(roleName: string): boolean {
    return roleName ? roleName.toLowerCase().includes('sp admin') : false
  }

 
}
